import { RenewalConfirmationTranslations } from '../types';

export const renewalConfirmation: RenewalConfirmationTranslations = {
  title: "Renovação Confirmada!",
  subtitle: "Obrigado por renovar sua confiança na Gándara International School",
  submissionDetails: "Detalhes da Sua Renovação",
  parentName: "Pai/Mãe/Tutor",
  childrenEnrolled: "Crianças Matriculadas",
  submissionDate: "Data da Solicitação",
  referenceNumber: "Número de Referência",
  paymentInstructions: "Instruções de Pagamento",
  bankAccount: "Conta Bancária",
  accountNumber: "ES70 2100 5752 6202 0018 6824",
  recipient: "Beneficiário",
  recipientName: "NOGUERA Y VALDES SL",
  concept: "Conceito do Pagamento",
  amount: "Valor a Transferir",
  deadline: "Prazo de Pagamento",
  earlyBirdDeadline: "28 de fevereiro de 2026 (desconto antecipado)",
  standardDeadline: "17 de março de 2026",
  pricingBreakdown: "Detalhamento de Custos",
  matriculaTotal: "Total Matrícula",
  annualTuitionTotal: "Total Mensalidades Anuais (10 meses)",
  earlyBirdDiscount: "Desconto Matrícula Antecipada",
  annualPaymentDiscount: "Desconto Pagamento Anual",
  grandTotal: "Total Geral",
  nextSteps: "Próximos Passos",
  steps: {
    transfer: "Realize a transferência bancária com os detalhes indicados acima. Não esqueça de incluir o conceito exato para que possamos identificar seu pagamento.",
    sendConfirmation: "Envie o comprovante de pagamento para info@gandaraschool.com",
    receiptConfirmation: "Confirmaremos o recebimento do seu pagamento em até 2 dias úteis",
    welcomeEmail: "Você receberá um e-mail de boas-vindas em junho com todas as informações para o início do ano letivo 2026/2027"
  },
  contactInfo: "Informações de Contato",
  questionsContact: "Você tem alguma pergunta? Estamos aqui para ajudá-lo:",
  printConfirmation: "Imprimir Confirmação",
  backToHome: "Voltar ao Início"
};
